module.exports = __webpack_public_path__ + "static/media/transaction.bd930a8a.svg";